import React from 'react';

import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { TabelaInstalacao } from '../../components/TabelaInstalacao';

export default function InstalacaoPage() {

    return (
        <>           
            <MenuMain >
                <TabelaInstalacao />
            </MenuMain>
            <AppFooter />    
        </>
    );
}
